import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Form } from '../';
import FIELDS from '../../data/fields';

interface Props {
  booking: any;
  handleUpdate: Function;
  handleError?: Function;
  updateOnChange: boolean;
  isDisabled: boolean;
}

class BookingUpdateDriversForm extends React.Component<Props> {
  /**
   * Handle field validation
   * @param {Object} data
   * @return {Object|Boolean}
   */
  handleValidate(data): any {
    return {
      additional_driver_cost: Number(data.additional_driver_cost),
    };
  }

  render() {
    const handleChange = (data) => {
      const validatedData = this.handleValidate(data);
      if (this.props.handleError !== undefined) {
        this.props.handleError(validatedData === false);
      }
      if (validatedData !== false) {
        this.props.handleUpdate(validatedData);
      }
    };
    return (
      <div className="field">
        <Form
          fields={FIELDS.bookings.updateDrivers}
          type="drivers"
          buttonText="Apply"
          handleSubmit={handleChange}
          hasButton={!this.props.updateOnChange}
          handleChange={(data) => {
            if (this.props.updateOnChange) {
              handleChange(data);
            }
          }}
          disabled={this.props.isDisabled}
          // Handle default value population
          getDispatch={(dispatch) => {
            const booking = this.props.booking;
            dispatch(
              actions.change(
                'drivers.additional_driver_cost',
                booking.additional_driver_cost || '0',
              ),
            );
          }}
        />
      </div>
    );
  }
}

export default connect()(BookingUpdateDriversForm);
